/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import ValidatorNumberField from "../../Validator/ValidatorNumberField";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const IncomeParentalAllowance = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasIncomeParentalAllowance: pcs.hasIncomeParentalAllowance,
    incomeParentalAllowanceAmount: pcs.incomeParentalAllowanceAmount,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Elterngeld</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Erhalten Sie Elterngeld?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Elterngeld"}
              name={"hasIncomeParentalAllowance"}
              value={formValue(values, "hasIncomeParentalAllowance")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              dependentValidationFields={["incomeParentalAllowanceAmount"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorNumberField
              fieldType={"money"}
              numberType={"float"}
              fullWidth={true}
              id="incomeParentalAllowanceAmount"
              name="incomeParentalAllowanceAmount"
              label="Mtl. Bruttobetrag"
              onBlur={handleBlur}
              registerValidators={registerValidators}
              isHighlighted={formValue(values, "hasIncomeParentalAllowance") === "yes"}
              error={!!errors["incomeParentalAllowanceAmount"]}
              helperText={errors["incomeParentalAllowanceAmount"]}
              margin="normal"
              value={formValue(values, "incomeParentalAllowanceAmount")}
              onChange={handleChange}
              disabled={formValue(values, "hasIncomeParentalAllowance") !== "yes"}
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default IncomeParentalAllowance;
